import { render, staticRenderFns } from "./SidoCode.vue?vue&type=template&id=e42605a6&scoped=true"
import script from "./SidoCode.vue?vue&type=script&lang=js"
export * from "./SidoCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42605a6",
  null
  
)

export default component.exports